import type { ImageStageLook } from './imageStage'

export const IMAGE_STAGE_STORAGE_KEY = 'minimany:image-stage:v1'
const MAX_REMEMBERED_NOTES = 300

type LookStorage = Pick<Storage, 'getItem' | 'setItem'>

function availableStorage(): LookStorage | null {
  if (typeof localStorage === 'undefined') return null
  return localStorage
}

function readAll(storage: LookStorage | null): Record<string, ImageStageLook> {
  if (!storage) return {}
  try {
    const raw = JSON.parse(storage.getItem(IMAGE_STAGE_STORAGE_KEY) ?? '{}') as unknown
    if (!raw || typeof raw !== 'object') return {}
    return Object.fromEntries(Object.entries(raw).filter(([, look]) => look === 'large' || look === 'compact')) as Record<string, ImageStageLook>
  } catch {
    return {}
  }
}

/** How this device shows a note's images when the person chose (Show or Hide images), else undefined: the note's weight decides. */
export function readImageStageLook(noteId: string, storage = availableStorage()): ImageStageLook | undefined {
  return readAll(storage)[noteId]
}

/** Remembered on this device only; the newest {@link MAX_REMEMBERED_NOTES} notes are kept. */
export function writeImageStageLook(noteId: string, look: ImageStageLook, storage = availableStorage()): void {
  if (!storage) return
  try {
    const all = readAll(storage)
    delete all[noteId]
    const kept = Object.entries({ ...all, [noteId]: look }).slice(-MAX_REMEMBERED_NOTES)
    storage.setItem(IMAGE_STAGE_STORAGE_KEY, JSON.stringify(Object.fromEntries(kept)))
  } catch {
    // The choice still holds for this session when browser storage is unavailable.
  }
}
